import { HttpParams } from '@angular/common/http'

type QueryParamValue = string | number | boolean | null | undefined

export type QueryParamsMap = Record<string, QueryParamValue>

export const buildConfigQueryParams = (params: QueryParamsMap): HttpParams => {
	return Object.entries(params).reduce((httpParams, [key, value]) => {
		if (value === null || value === undefined) return httpParams
		if (typeof value === 'string' && value.trim() === '') return httpParams
		return httpParams.set(key, String(value))
	}, new HttpParams())
}
